let customGlobalObject;

window.addEventListener('DOMContentLoaded', (event) => { 
  
  customGlobalObject = (function() {

    let self,
        customObject = function() {
          self = this; 
        },
        cOFn = customObject.prototype;

    cOFn.fn = cOFn;

    cOFn.months = {
      'short' : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      'full' : ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    };
    cOFn.desktop = parseFloat('1200px'.replace(/\D+/, ''));
    cOFn.smallDesktop = parseFloat(''.replace(/\D+/, ''));
    cOFn.tablet = parseFloat('767px'.replace(/\D+/, ''));
    cOFn.mobile = parseFloat('479px'.replace(/\D+/, ''));
    cOFn.window = $(window);
    cOFn.document = $('html');
    cOFn.body = $('body');

    cOFn.isUndefined = function(val) {
      return typeof val == 'undefined';
    }

    cOFn.isFunction = function(val) {
      return typeof val == 'function';
    }

    cOFn.jsonp_custom = function(url, callback) {

      function removeCallback(callbackName){

        delete window[callbackName];
        document.body.removeChild(script);

      }

      let callbackName = 'jsonp_callback_' + Math.round(100000 * Math.random());

      window[callbackName] = function(data) {

        removeCallback(callbackName);
        callback(data);			

      }

      let script = document.createElement('script');
      script.src = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'c=' + callbackName;

      script.onerror = function(){

        removeCallback(callbackName);
        callback('An error occured while processing the request.');

      }

      document.body.appendChild(script);

    }

    cOFn.handleScroll = function(elm) {

      elm = $(typeof elm == 'string' && /#/.test(elm) ? elm : elm.hash);

      if(!elm.length) return;

      $('html, body').stop().animate({scrollTop: elm.offset().top}, 450);

    }

    cOFn.handleGeneralChanges = function() {

      (function() {

        let inlineRatings = $('[data-bv-show="inline_rating"]');

        if(!inlineRatings.length) return;

        let observer = new MutationObserver(function() { 
          let ratingSummaryNumReviews = inlineRatings.find('.bv_text');
          if(ratingSummaryNumReviews.length) {
            observer.disconnect();
            inlineRatings.append('<div class="bv-text-custom" id="bv-text-custom"><a href="#">(Read Reviews)</a></div>');        
            inlineRatings.each(function(index, item) {
              let inlineRating = $(this);
              inlineRating.find('.bv-text-custom a').attr('href', inlineRating.data('bv-redirect-url'));          
              if(inlineRating.find('.bv_text').text() == 0) inlineRating.find('.bv-text-custom').remove();
            });
          }
        }); 

        observer.observe(inlineRatings[0], { childList: true, subtree: true });
        
      })();
      
      (function() {
      
        let url = new URL(window.location);    
        
        if(self.isUndefined(url.hash) || url.hash == '') return;
        
        self.handleScroll(url.hash);
      
      })();
      
      (function() {
        
        let promoBanner = $('.promo_banner');

        if(!promoBanner.length) return;

        let promo_banner = Cookies.get('promo_banner');

        if (promo_banner != 'dismiss') {
          $('body').addClass('promo_banner-show');
          promoBanner.on('click', '.promo_banner-close', function(){
            $('body').removeClass('promo_banner-show');
            Cookies.set('promo_banner', 'dismiss', { expires: 30 });
          });
        }
      
      })();
      
      (function() {
      
        let supports_video = function(){
          return !!document.createElement('video').canPlayType;
        }

        let videoSection = {
          init: function(){

            //Initialize lazy videos
            lazyframe('.lazyvideo--autoplay--true', {
              initinview: true,
            });

            lazyframe('.lazyvideo--autoplay--false', {
              initinview: false,
            });

            //Wrap product description iframes in responsive lazyframe div
            $('.product_section .description').find('iframe').wrap('<div class="lazyframe" data-ratio="16:9"></div>');

            function hideTextElements(parent) {
              parent.find('.caption').hide();
              parent.find('.action_button').hide();
            }

            var videoElement = $('.js-video.hide-text-on-video.video-autoplay--true').parents('.js-video-section');
            hideTextElements(videoElement);


            if($('.js-video').hasClass('hide-text-on-video') && $('.js-video').hasClass('video-autoplay--true')){
              var videoSection = $('.js-video').parents('.js-video-section');
              hideTextElements(videoSection);
            }

            $(".video-section .lazyvideo.hide-text-on-video").on('click', function(){
              var videoSection = $(this).parents('.js-video-section');
              hideTextElements(videoSection);
            })

            $('[data-play-video-button], video.hide-text-on-video, .lazyvideo--autoplay--false').on('click', function(){
              //Target parent lazyframe
              var videoSection = $(this).parents('.js-video-section');
              var lazyElement = videoSection.find('.lazyframe');
              var videoWrapper = videoSection.find('.js-video');
              if(videoWrapper.data('mp4') || videoWrapper.data('ogv')) {
                videoSection.find('video')[0].play();
                if(videoSection.find('.js-video.hide-text-on-video').length) {
                  hideTextElements(videoSection);
                }
              } else{
                //create iframe and add settings
                var lazyIframe = document.createElement('iframe');
                iframeSrc = lazyElement.data('src');
                cleanIframeSrc = iframeSrc.substring(0, iframeSrc.indexOf('?')) + '?&autoplay=1';
                lazyIframe.src = cleanIframeSrc;
                lazyIframe.setAttribute('allowfullscreen', true);
                lazyIframe.setAttribute('frameborder', 0);
                //Append iframe to lazyframe
                lazyElement.append(lazyIframe);
                if(videoSection.find('.js-video.hide-text-on-video').length) {
                  hideTextElements(videoSection);
                }
              }
            });
          },
          unload: function($target){
            $target.find('[data-play-video]').off('click');
            $target.find('video.hide-text-on-video').off('click');
          }
        }    
        
        videoSection.init();
      
      })();
      
      (function() {
      
        let colorVariants = $('.engoj_select_color.variant-product');
        
        if(!colorVariants.length) return;
               
        colorVariants.each(function(item, index) {
        
          let _this = $(this);
          
          _this.parent().parent().append(_this.addClass('color-variant-custom'));
        
        });
      
      })();
      
      (function() {
      
        let bannerItems = $('[class*="section-banner-"] .banner-item');
        
        if(!bannerItems.length) return;
        
        bannerItems.click(function() {
        
          let _this = $(this);
          
          window.location.href = _this.find('.box-img').attr('href');
        
        });
      
      })();
      
      (function() {
        
        window.addEventListener('load', function() {
      
          setTimeout(function() {

            let paypalButton = $('.payment-information-methods .paypalLight');

            if(!paypalButton.length) return;

            let buttonHeight = paypalButton.parent().css('height');

            paypalButton.css('height', buttonHeight);
            paypalButton.css('max-height', buttonHeight);
            paypalButton.contents().find('div').css('height', buttonHeight);

          }, 50);

        });
      
      })();
      
      return self;
      
    }
    
    cOFn.handleProductPageChanges = function(types) {
        
        if(!Array.isArray(types)) return self;
        
        $.each(types, function(index, type) {
          
          let typeFiltered = typeof type == 'string' ? type : ($.isPlainObject(type) && type.hasOwnProperty('type') ? type['type'] : '');
          
          switch(typeFiltered) {
              
            case 'reviews':   
    
              let ratingSummary = $('[data-bv-show="rating_summary"]');

              if(!ratingSummary.length) return;

              let observer = new MutationObserver(function() { 
                let ratingSummaryNumReviews = ratingSummary.find('.bv_numReviews_text');
                if(ratingSummaryNumReviews.length) {
                  observer.disconnect();
                  ratingSummary.find('.bv_main_container_row_flex').append('<div class="bv-text-custom" id="bv-text-custom"><a href="#BVRRSearchContainer">Read Reviews</a></div>');
                  $('.bv-text-custom a').click(function(e) {
                    e.preventDefault();
                    let reviewsContainer = $(this.hash);
                    if(!reviewsContainer.length) return;
                    self.handleScroll(this.hash);
                  });
                }
              }); 

              observer.observe(ratingSummary[0], { childList: true, subtree: true });
              
              break;
              
            case 'tabs': 
              
              let tabs = $('ul.tabs');
                           
              if(!tabs.length) return;
              
              tabs.find(' > li > a').attr('data-no-instant', true);
              tabs.find(' > li > a').on('click', function(e) {
                e.preventDefault();
                let _this = $(this);
                let contentLocation = _this.attr('href');
                if(contentLocation.charAt(0)=="#") {
                  tabs.find(' > li > a.active').removeClass('active');
                  _this.addClass('active');
                  _this.parents('ul.tabs').next().find(contentLocation).show().css({'display': 'block'}).addClass('active').siblings().hide().removeClass('active');
                }
              });
              
              break;
          }
          
        });
      
      return self;
      
    }
        

    return new customObject()
    					.handleGeneralChanges()
    					.handleProductPageChanges(['reviews', 'tabs']);

  })();
  
});